const addSlashToEndString = (location?: string): string => {
  if (typeof location !== 'string') {
    return '/';
  }
  return location.endsWith('/') ? location : `${location}/`;
};

export { addSlashToEndString };
